// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabChats-modulechatWrap___my9M";
var _2 = "RequestProfileTabChats-moduleloader__kGw5X";
var _3 = "RequestProfileTabChats-modulerequestProfileTabChats__Sb9Eo";
export { _1 as "chatWrap", _2 as "loader", _3 as "requestProfileTabChats" }
